import vue from "../main";

let translateObject = function(obj) {
  for (let propertyName in obj) {
    if (typeof obj[propertyName] === "string") {
      obj[propertyName] = vue.$t("$objectTranslator." + obj[propertyName].replace(/[."\s]/g, ""));
    }
    if (typeof obj[propertyName] === "object") {
      obj[propertyName] = translateObject(obj[propertyName]);
    }
  }

  return obj;
};

export default translateObject;
